import { styled } from '@mui/material';
import Paper from '@mui/material/Paper';
import { INDICATOR_CARD_WIDTH } from 'modules/decision/constants';

const IndicatorCardPaper = styled(Paper, {
    shouldForwardProp: (prop) => prop !== 'fullWidth',
})<{ fullWidth?: boolean }>(({ theme, fullWidth }) => ({
    borderRadius: theme.spacing(1),
    display: 'flex',
    flexDirection: 'column',
    flexShrink: 0,
    gap: theme.spacing(2),
    justifyContent: 'space-between',
    padding: theme.spacing(2),
    width: '100%',
    maxWidth: fullWidth ? undefined : `min(25vw, ${INDICATOR_CARD_WIDTH}px)`,
}));

export default IndicatorCardPaper;
